// extracted by mini-css-extract-plugin
export default {"dashed":"DashedBtn_dashed__GjZCN","thin":"DashedBtn_thin__QLV9i","btnLink":"DashedBtn_btnLink__xvcUp"};